export class CreatorInfoAdAccountSupplementRequest {
    public AdAccountId!: string;
    public PageId!: string;
}
